"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var RiotBarLoader = function (_super) {
  __extends(RiotBarLoader, _super);

  function RiotBarLoader(props) {
    return _super.call(this, props) || this;
  }

  RiotBarLoader.prototype.componentDidMount = function () {
    // start loading
    this.loadRiotBar();
  };

  RiotBarLoader.prototype.render = function () {
    return null; // we dont actually render anything, the riotbar script does
  };

  RiotBarLoader.prototype.getRiotBarUrl = function () {
    var _a = this.props,
        _b = _a.environment,
        environment = _b === void 0 ? 'production' : _b,
        locale = _a.locale,
        product = _a.product,
        version = _a.version; // Default the cdnHost and environmentPath vars

    var cdnHost = 'lolstatic-a.akamaihd.net';
    var environmentPath = 'live'; // If the environment is not production, reset the cdn host and environment path

    if (!['production', 'prod', 'live'].includes(environment)) {
      cdnHost = 'cdn.rgpub.io';
      environmentPath = 'test'; // If no version was passed, and we're in a staging environment, we use master

      if (!version) {
        version = 'master';
      } // New CDN strategy for test only


      return "https://" + cdnHost + "/private/" + environmentPath + "/riotbar/" + version + "/" + product + "." + locale + ".js";
    } // if no version has been set, set it to latest


    if (!version) {
      version = 'latest';
    }

    return "https://" + cdnHost + "/riotbar/" + environmentPath + "/" + version + "/" + product + "." + locale + ".js";
  };

  RiotBarLoader.prototype.loadRiotBar = function () {
    if (!document.getElementById('riotbar-script')) {
      var scriptEl = document.createElement('script');
      scriptEl.src = this.getRiotBarUrl();
      scriptEl.id = 'riotbar-script';

      if (this.props.onLoad && typeof this.props.onLoad === 'function') {
        var onloadFunc_1 = this.props.onLoad;
        document.addEventListener('riotbar_onshowcomplete', function () {
          onloadFunc_1();
        });
      }

      if (this.props.onAuthUpdate && typeof this.props.onAuthUpdate === 'function') {
        var onAuthUpdateFunc_1 = this.props.onAuthUpdate;
        document.addEventListener('riotbar_authcheckcomplete', function () {
          onAuthUpdateFunc_1();
        });
      }

      document.getElementsByTagName('head')[0].appendChild(scriptEl);
    }
  };

  return RiotBarLoader;
}(react_1.Component);

exports.default = RiotBarLoader;